export default __webpack_public_path__ + "img/icon-flag-cn.asset.2ca81114.jpg";